import { Link } from 'react-router-dom';
import { categories, stats } from '@/mocks/homepage';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-300">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-vidicon-line text-xl text-white"></i>
              </div>
              <span className="font-heading text-lg font-bold text-white">美女视频精选</span>
            </div>
            <p className="text-sm leading-relaxed text-background-400 mb-4">
              致力于为用户提供高清美女视频在线观看服务，涵盖时尚穿搭、生活写真、才艺展示等多元内容。每日更新，发现更多美丽精彩瞬间。
            </p>
            <div className="flex items-center gap-3">
              {stats.slice(0, 3).map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-sm font-semibold text-accent-400">{stat.value}</div>
                  <div className="text-xs text-background-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-white mb-4">内容分类</h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-400 hover:text-accent-400 transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-white mb-4">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-400 hover:text-accent-400 transition-colors">首页</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-accent-400 transition-colors">关于我们</Link>
              <a href="/about#contact" className="text-sm text-background-400 hover:text-accent-400 transition-colors">联系我们</a>
              <a href="#" className="text-sm text-background-400 hover:text-accent-400 transition-colors">隐私政策</a>
              <a href="#" className="text-sm text-background-400 hover:text-accent-400 transition-colors">服务条款</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-white mb-4">关注我们</h4>
            <p className="text-sm text-background-400 mb-4 leading-relaxed">
              获取最新视频更新通知，不错过任何精彩内容。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-white transition-all duration-200" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-white transition-all duration-200" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-white transition-all duration-200" aria-label="抖音">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-white transition-all duration-200" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 美女视频精选合集. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-background-500 hover:text-accent-400 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-accent-400 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-accent-400 transition-colors">Cookie政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}